import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const {
    _class: {
        Common: { Price },
    },
} = Mobi2Go;

const CreditBalance = ({ value }) => {
    if (!Mobi2Go.headoffice.credit_program.enabled) {
        return null;
    }

    const { t } = useTranslation('common');

    return (
        <div
            data-credit-balance
            className="m2g-customer-credit-balance m2g-text--small"
        >
            <span
                className="m2g-customer-credit-utility"
            />
            <div
                data-credit-balance-title
                className="m2g-customer-credit-balance-label"
            >
                {t('credit_program_title')}
            </div>
            <div
                data-credit-balance-text
                className="m2g-customer-credit-balance-value"
            >
                {t('price', {
                    price: value,
                })}
            </div>
        </div>
    );
};

CreditBalance.propTypes = {
    value: PropTypes.instanceOf(Price),
};

CreditBalance.defaultProps = {
    value: null,
};

export default CreditBalance;
